export default __webpack_public_path__ + "static/placeholder-691870387b1db5e371266d7ae794c986.jpg";